import { Component } from "react";
import AppContext from "./Context";
import ApiGateway from "./ApiGateway";

export default class UnAvailableWindow extends Component {
  constructor() {
    super();
    this.state = {
      isVisibile: false,
    };
    AppContext.attachMember("openServiceUnAvailableWindow", this.openServiceUnAvailableWindow);
  }

  openServiceUnAvailableWindow = (open) => {
    this.setState({ isVisibile: open }, () => {
      setTimeout(() => {
        if (open === true) {
            ApiGateway.checkServiceAvailable();
        }
      }, 10000);
    });
  };

  render() {
    return (
      this.state.isVisibile ? (
        <div className="unAvailability-Window-012">
          <div className="unavailability-card-001 card">
            {/* <div className="unavailability-caption-001">
              <h3>Sevice Unavailable</h3>
              <p>We Will be right back..</p>

            </div> */}
          </div>
        </div>
      ) : null
    );
  }
}
